module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1gfrpl/OEBPS/images/9780740798849_cvi.jpg?1707485958049",
      "alt": "This image is the cover for the book Tee Time in Berzerkistan, Doonesbury"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Tee Time in Berzerkistan, Doonesbury\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("No rogue regime ever needed its evildoing professionally reframed more urgently than Greater Berzerkistan, whose president-for-life Trff Bmzklfrpz (pronounced \"Ptklm\") needs to spin a recent round of ethnic cleansing. Fortunately, the pariah state (and its 50-hole golf course, built overnight by Kurds and Jews) borders Iran, a fact that K Street uberlobbyist Duke is retained to parlay into a major U.S. arms package.")]), _c('p', [_vm._v("Meanwhile, across town, the crumbling of the newspaper industry crushes Rick Redfern's hope of continuing employment. After 35 years at the "), _c('i', [_vm._v("Washington Post")]), _vm._v(", he is ejected into the blogosphere, where his prose now battles it out with that of 1,186,783,465 rivals, including Roland Hedley, who takes the art of Twittering to a new self-reverential low.")]), _c('p', [_vm._v("Truly, everyone in Doonesburyland is struggling to adapt. While white Washington insiders scramble to acquire some African American friends, longtime black conservative Clyde schemes to score Obama's Blackberry number, Clinton-era Dems are forced to attend the president-elect's \"No Drama School,\" and Jimmy Thudpucker once again reboots his career--this time as a cell phone ring-tone artist.")]), _c('p', [_vm._v("No one ever said change was pretty.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      G. B. Trudeau\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing, LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0